import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/index/login'
import Vcode from '@/components/verificationCode/index'
import Reset from '@/components/verificationCode/resetpwd'
import Change from '@/components/verificationCode/changepwd'
import Applets from '@/components/index/logins'
import Index from '@/components/index/index'
import Detail from '@/components/index/detail'
import Calendar from '@/components/calendar/calendar'
import Record from '@/components/record/record'
import File from '@/components/file/index'
import Video from '@/components/video/index'
import Videos from '@/components/video/video'
import Handout from '@/components/handout/index'
import Livevod from '@/components/livevod/index'
import Coupon from '@/components/coupon/index'
import Report from '@/components/report/index'
import Reports from '@/components/report/report'
import ReportData from '@/components/report/reports'
import ReportScreen from '@/components/report/reportscreen'
import Share from '@/components/report/share'
import Attendance from '@/components/attendance/index'
import Beforeclass from '@/components/beforeClass/index'
import Reportdetail from '@/components/attendance/detail'
import Lottery from '@/components/lottery/index'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: Index,
    },
    {
      path: '/login',
      component: Login,
    },
    {
      path: '/reset',
      component: Reset,
    },
    {
      path: '/change',
      component: Change,
    },
    {
      path: '/logins',
      component: Applets,
    },
    {
      path: '/index',
      name: 'index',
      component: Index,
    },
    {
      path: '/list/detail',
      component: Detail,
    },
    {
      path: '/file',
      component: File,
    },
    {
      path: '/video',
      component: Video,
    },
    {
      path: '/videos',
      component: Videos,
    },
    {
      path: '/livevod',
      component: Livevod,
    },
    {
      path: '/handout',
      component: Handout,
    },
    {
      path: '/calendar',
      component: Calendar,
    },
    {
      path: '/record',
      component: Record,
    },
    {
      path: '/coupon',
      component: Coupon,
    },
    {
      path: '/report',
      component: Report,
    },
    {
      path: '/reports',
      component: Reports,
    },
    {
      path: '/reportdata',
      component: ReportData,
    },
    {
      path: '/reportscreen',
      component: ReportScreen,
    },
    {
      path: '/share',
      component: Share,
    },
    {
      path: '/attendance',
      component: Attendance,
    },
    {
      path: '/beforeclass',
      component: Beforeclass,
    },
    {
      path: '/reportdetail',
      component: Reportdetail,
    },
    {
      path: '/lottery',
      component: Lottery,
    },
    {
      path: '/selfService',
      name: 'selfService',
      component: () =>
        import(
          '@/components/coursePackages/selfService.vue'
        ),
    },
    {
      path: '/commentReview',
      name: 'commentReview',
      component: () =>
        import(
          '@/components/coursePackages/commentReview.vue'
        ),
    },
    {
      path: '/resume',
      name: 'resume',
      component: () =>
        import(
          '@/components/coursePackages/resume.vue'
        ),
    },
    {
      path: '/wechat',
      name: 'wechat',
      component: () =>
        import(
          '@/components/coursePackages/wechat.vue'
        ),
    },
    {
      path: '/face',
      name: 'face',
      component: () =>
        import(
          '@/components/coursePackages/face.vue'
        ),
    },
    { path: '*', redirect: '/' }
  ]
})

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js